import { APP_INITIALIZER, NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './modules/shared/shared.module';

import { MaterialModule } from './modules/material/material.module';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask } from 'ngx-mask';
import { DATE_PIPE_DEFAULT_OPTIONS } from "@angular/common";
import { GtmService } from './services/gtm.service';
import { CookieConsentService } from './services/cookie-consent-service.service';

export function initializeGtm(gtmService: GtmService) {
  return () => gtmService.loadGtm();
}

export function initializeCookieConsent(cookieService: CookieConsentService) {
  return () => cookieService.loadCookieScripts();
}


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    MaterialModule,
    HttpClientModule,
    CommonModule,
    NgxMaskDirective,
    NgxMaskPipe,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeGtm,
      deps: [GtmService],
      multi: true
    },
    {
    provide: APP_INITIALIZER,
    useFactory: initializeCookieConsent,
    deps: [CookieConsentService],
    multi: true
  },
    provideAnimations(),
    provideEnvironmentNgxMask(),
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { dateFormat: "longDate" }
    }],
  bootstrap: [AppComponent],
})
export class AppModule {}
